<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.401" height="20.401" viewBox="0 0 14.401 14.401"><defs></defs><path :style="getSvgColor" class="a" d="M2.72,4.88h7.92a1.44,1.44,0,0,0,1.44,1.44h1.44a1.44,1.44,0,0,0,1.44-1.44h.72a.72.72,0,0,0,0-1.44h-.72A1.44,1.44,0,0,0,13.521,2h-1.44a1.44,1.44,0,0,0-1.44,1.44H2.72a.72.72,0,1,0,0,1.44Zm9.361-1.44h1.44V4.88h-1.44Zm3.6,5.04H9.2A1.44,1.44,0,0,0,7.76,7.04H6.32A1.44,1.44,0,0,0,4.88,8.48H2.72a.72.72,0,1,0,0,1.44H4.88a1.44,1.44,0,0,0,1.44,1.44H7.76A1.44,1.44,0,0,0,9.2,9.92h6.48a.72.72,0,0,0,0-1.44ZM6.32,9.92V8.48H7.76V9.92Zm9.361,3.6h-2.16a1.44,1.44,0,0,0-1.44-1.44h-1.44a1.44,1.44,0,0,0-1.44,1.44H2.72a.72.72,0,1,0,0,1.44H9.2a1.44,1.44,0,0,0,1.44,1.44h1.44a1.44,1.44,0,0,0,1.44-1.44h2.16a.72.72,0,0,0,0-1.44Zm-5.04,1.44v-1.44h1.44v1.44Z" transform="translate(-2 -2)"/></svg>
</template>

<script>
export default {
  name: "abacusSvg",
  props: {
    navColor: {
      type: Object,
      default: () => {
        return {
          color: "#000000"
        };
      }
    },
  },
  computed: {
    getSvgColor() {
      if(!this.navColor) {
        return {
          fill: "#000000"
        };
      }
      return {
        fill: this.navColor.color || "#fff",
      };
    },
  },
}
</script>

